import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Category
export const categoryList = (params = '') => Http.get(`/marketing-campaign-categories${serialize(params)}`)
export const categoryCreate = (params = '') => Http.post('/marketing-campaign-categories', params)
export const categoryByID = (params = '') => Http.get(`/marketing-campaign-categories/${params}`)
export const categoryUpdate = (params = '') => Http.put(`/marketing-campaign-categories/${params.id}`, params)
export const categoryDestroy = (params = '') => Http.delete(`/marketing-campaign-categories/${params.id}`)
